import React, { useCallback, useState } from "react";
import CraftIdentityMatchesItemButton from "./CraftIdentityMatchesItemButton";
import CraftIdentityMatchesDetails from "./CraftIdentityMatchesDetails";

const CraftIdentityMatchItem = ({ matchesRef, item }) => {
  const getColor = useCallback((item) => {
    const data = [
      item.birth_day.status,
      item.birth_month.status,
      item.birth_year.status,
      item.category.status,
    ];

    const filtered = data.filter((status) => status === "Not Owned");

    if (filtered.length > 2) return "#ffffff";
    else if (filtered.length === 2) return "#f6360c";
    else if (filtered.length === 1) return "#f5e417";
    else return "#06ce22";
  }, []);

  const isReadyToCraft = useCallback(
    (item) => {
      return getColor(item) === "#06ce22";
    },
    [getColor]
  );

  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState(null);

  return (
    <li className="card-details__craft-item">
      <CraftIdentityMatchesItemButton
        matchesRef={matchesRef}
        color={getColor(item)}
        variables={[item.custom_one, item.custom_two]}
        id={item.id}
        setDetails={setDetails}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      >
        {item.name}
      </CraftIdentityMatchesItemButton>
      {details !== null ? (
        <CraftIdentityMatchesDetails
          item={details}
          isReadyToCraft={isReadyToCraft(details)}
        />
      ) : null}
    </li>
  );
};

export default CraftIdentityMatchItem;

// import React, { useCallback, useState } from "react";
// import CraftIdentityMatchesItemButton from "./CraftIdentityMatchesItemButton";
// import CraftIdentityMatchesDetails from "./CraftIdentityMatchesDetails";

// const CraftIdentityMatchItem = ({ matchesRef, item }) => {
//   const getColor = useCallback((item) => {
//     const data = [
//       item.birth_day.status,
//       item.birth_month.status,
//       item.birth_year.status,
//       item.category.status,
//     ];

//     const filtered = data.filter((status) => status === "Not Owned");

//     if (filtered.length > 2) return "#ffffff";
//     else if (filtered.length === 2) return "#f6360c";
//     else if (filtered.length === 1) return "#f5e417";
//     else return "#06ce22";
//   }, []);

//   const isReadyToCraft = useCallback(
//     (item) => {
//       return getColor(item) === "#06ce22";
//     },
//     [getColor]
//   );

//   const [details, setDetails] = useState(null);

//   return (
//     <li className="card-details__craft-item">
//       <CraftIdentityMatchesItemButton
//         matchesRef={matchesRef}
//         color={getColor(item)}
//         variables={[item.custom_one, item.custom_two]}
//         id={item.id}
//         setDetails={setDetails}
//       >
//         {item.name}
//       </CraftIdentityMatchesItemButton>
//       {details !== null ? (
//         <CraftIdentityMatchesDetails
//           item={details}
//           isReadyToCraft={isReadyToCraft(details)}
//         />
//       ) : null}
//     </li>
//   );
// };

// export default CraftIdentityMatchItem;
